<template>
    <div class="list-item" :class="{ 'tiktok-list': network === 'tiktok' }">
        <template v-if="network !== 'tiktok'">
            <div class="legend">
                <p>{{ $t('dash.reporting.pdf.listItem.date') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.type') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.publication') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.print') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.comments') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.shares') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.reactions') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.engagement') }}</p>
            </div>

            <div class="item" v-for="post in posts" :key="post.id">
                <p>{{ getFormatDate(post.created_time) }}</p>
                <div class="type-content"><div class="badge-type-post">{{ post.type == "snippet" ? "lien" : post.type }}</div></div>
                <div class="publication">
                    <div class="picture">
                        <i v-if="post.type && post.type == 'NATIVE_DOCUMENT'"  class="fa-regular fa-file-pdf"></i>
                        <img v-else-if="post.attachment_url" :src="post.attachment_url">
                        <i v-else class="fa-regular fa-image-slash"></i>
                    </div>
                    <p>{{post.message}}</p>
                </div>
                <p class="impression number">{{post.post_impressions ? post.post_impressions  : 0 }}</p>
                <p class="comment number">{{ post.comments_count ? post.comments_count : 0 }}</p>
                <p class="share number">{{ post.shares_count ? post.shares_count : 0 }}</p>
                <p class="reaction number">{{ post.post_reactions_sum ? post.post_reactions_sum : 'like_count' in post  ? post.like_count : ''}}</p>
                <p class="engagement number">{{ post.reach_engagement ? post.reach_engagement.toFixed(2)+'%' : '' }}</p>
            </div>
        </template>

        <!-- TikTok-specific columns -->
        <template v-else>
            <div class="legend tiktok-legend">
                <p>{{ $t('dash.reporting.pdf.listItem.date') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.publication') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.type') }}</p>
                <p>{{ $t('dash.reporting.impression') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.comments') }}</p>
                <p>{{ $t('dash.reporting.pdf.listItem.shares') }}</p>
                <p>Likes</p>
            </div>

            <div class="item tiktok-item" v-for="post in posts" :key="post.id">
                <p>{{ getFormatDate(post.created_time) }}</p>
                <div class="publication">
                    <div class="picture">
                        <img v-if="post.attachment_url" :src="post.attachment_url">
                        <i v-else class="fa-regular fa-image-slash"></i>
                    </div>
                    <p>{{post.message}}</p>
                </div>
                <div class="type-content"><div class="badge-type-post">{{ post.type }}</div></div>
                <p class="impression number">{{ post.post_impressions ? numberSpacing(post.post_impressions) : 0 }}</p>
                <p class="comment number">{{ post.comments_count ? post.comments_count : 0 }}</p>
                <p class="share number">{{ post.shares_count ? post.shares_count : 0 }}</p>
                <p class="like number">{{ post.like_count ? post.like_count : 0 }}</p>
            </div>
        </template>

    </div>
</template>

<script>
    export default {
        props: {
            posts: {
                type: Array,
                default: function() {
                    return []
                }
            },
            network: {
                type: String,
                default: ''
            }
        },

        methods: {
            getFormatDate(dateString) {
                return (new Date(dateString)).toLocaleString('fr-FR',{year: 'numeric', month: 'short', day: 'numeric'})
            },
            numberSpacing(number) {
                if (number === null || number === undefined) return 'N/A';
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
        },
    }
</script>
